<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <check-fnwallet v-if="!hasPacket"></check-fnwallet>
        <futurocoins-from-mining v-if="hasPacket"></futurocoins-from-mining>
        <form autocomplete="off">
            <b-row id="profile_edit_data_header"
                   class="profile-edit-data-header">
                <b-col lg="12">
                    <h3>Profile - edit data</h3>
                </b-col>
                <textfield :sending="progress"
                           :show-errors="showErrors"
                           :label="'first name'"
                           :field-key="'first_name'"
                           :property="'firstName'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
                <textfield :sending="progress"
                           :show-errors="showErrors"
                           :label="'last name'"
                           :field-key="'last_name'"
                           :property="'lastName'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
                <b-col lg="4" class="empty"></b-col>
                <email></email>
                <phone :sending="progress"
                       :show-errors="showErrors"
                       :update-value="updateValue"
                       :is-verified="isVerified"></phone>
                <b-col lg="4" class="empty"></b-col>
                <textfield :sending="progress"
                           :show-errors="showErrors"
                           :label="'street'"
                           :field-key="'street'"
                           :property="'street'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
                <textfield :sending="progress"
                           :show-errors="showErrors"
                           :label="'city'"
                           :field-key="'city'"
                           :property="'city'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
                <b-col lg="4" class="empty"></b-col>
                <textfield :sending="progress"
                           :show-errors="showErrors"
                           :label="'zip code'"
                           :field-key="'zip'"
                           :property="'postalCode'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
                <b-col lg="4">
                    <autocomplete-component :default-value="defaultValues.country"
                                            :disabled="progress || isVerified"
                                            :field-key="'country'"
                                            :label="'Country'"
                                            :list="countries"
                                            :rules="{ required: true, isOnList: [countries] }"
                                            :show-errors="showErrors"
                                            :update-value="updateValue"></autocomplete-component>
                </b-col>
                <b-col lg="4" class="empty"></b-col>
                <birthdate :sending="progress"
                           :show-errors="showErrors"
                           :update-value="updateValue"
                           :is-verified="isVerified"></birthdate>
                <gender :sending="progress"
                        :show-errors="showErrors"
                        :update-value="updateValue"
                        :change-event="toggleCompanyFields"
                        :is-verified="isVerified"></gender>
                <b-col lg="4" class="empty"></b-col>
                <textfield v-if="showCompanyFields"
                           :sending="progress"
                           :show-errors="showErrors"
                           :label="'company name'"
                           :field-key="'company_name'"
                           :property="'companyName'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
                <textfield v-if="showCompanyFields"
                           :sending="progress"
                           :show-errors="showErrors"
                           :label="'company registration number'"
                           :field-key="'company_registration_number'"
                           :property="'companyRegistrationNumber'"
                           :update-value="updateValue"
                           :is-verified="isVerified"></textfield>
            </b-row>
            <b-row class="row-buttons">
                <b-col cols="12"
                       lg="8">
                    <router-link :to="{ name: 'Profile' }" class="button--cancel-red">Cancel</router-link>
                    <button class="button--primary"
                            :class="{ 'button--progress': progress }"
                            type="button"
                            @click="!progress ? validate() : false"
                            v-if="!isVerified">Save data</button>
                </b-col>
            </b-row>
        </form>
    </b-col>
</template>

<script>
    import CheckFnwallet from './dashboard/CheckFnwallet.vue';
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue';
    import Birthdate from './profile-edit-data/Birthdate.vue';
    import Email from './profile-edit-data/Email.vue';
    import Gender from './profile-edit-data/Gender';
    import Phone from './profile-edit-data/Phone.vue';
    import Textfield from './profile-edit-data/Textfield.vue';

    export default {
        dependencies: ['api', 'popup', 'status', 'user'],
        components: { CheckFnwallet, FuturocoinsFromMining, Birthdate, Email, Gender, Phone, Textfield },
        data () {
            return {
                progress            : false,
                showErrors          : false,
                showCompanyFields   : false,
                userData            : {
                    firstName                   : '',
                    lastName                    : '',
                    street                      : '',
                    city                        : '',
                    postalCode                  : '',
                    country                     : '',
                    phoneNumber                 : '',
                    birthDate                   : '',
                    gender                      : '',
                    companyName                 : '',
                    companyRegistrationNumber   : ''
                }
            }
        },
        computed: {
            countries () {
                return this.$store.getters.countries;
            },
            defaultValues () {
                return this.$store.getters.user;
            },
            hasPacket () {
                return this.$store.getters.user.position !== 0;
            },
            isVerified () {
                return this.$store.getters.user.isVerified;
            }
        },
        methods: {
            toggleCompanyFields (gender) {
                this.showCompanyFields = gender === 'company';
            },

            updateValue (field, value) {
                this.userData[field] = value;
            },

            validate (e) {
                this.showErrors = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    } else {
                        this.showErrors = true;
                    }
                })
            },
            submit () {
                this.progress = true;

                // Clear company data if gender is not company
                if (this.userData.gender !== 'company') {
                    this.userData.companyName = '';
                    this.userData.companyRegistrationNumber = '';
                }

                this.$http.post(this.api.user.update, this.userData).then(response => {
                    this.user.reloadData(response.data).then(() => {
                        this.popup.show('Data was changed successfully!');
                        this.progress = false;
                        this.$router.push({ name: 'Profile' })
                    })
                }, error => {
                    let message = error.data.message[Object.keys(error.data.message)[0]];
                    switch (error.status) {
                        case 422:
                            this.popup.show(message);
                            break;
                        default:
                            if (this.status['status' + error.status]) {
                                this.status['status' + error.status]();
                            } else {
                                this.popup.show(message);
                            }
                    }
                    this.progress = false;
                })
            }
        },
        beforeMount () {
            let gender = this.$store.getters.user.gender;

            if (gender === 'company') {
                this.showCompanyFields = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .space{
        margin-bottom: 30px;
    }

    .empty{
        height: 1px;
    }

    .profile-edit-data-header{
        h3{
            margin: 30px 0;
        }
    }

    .row-buttons{
        margin-top: 30px;
        text-align: right;
        word-spacing: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/ProfileEditDataContent.vue